import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { NgxMaskModule } from 'ngx-mask';
import { JwtInterceptor } from 'app/core/http/interceptors/jwt.interceptor';
import { JwtModule } from '@auth0/angular-jwt';
import { EncrDecrService } from 'app/core/http/services/encr-decr.service';
import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import ptBr from '@angular/common/locales/pt';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoginComponent } from './pages/login/login.component';
import { NotfoundComponent } from './pages/notfound/notfound.component';
import { RecuperarSenhaComponent } from './pages/recuperar-senha/recuperar-senha.component';
import { HeaderComponent } from './layout/header/header.component';
import { SidebarMenuComponent } from './layout/sidebar-menu/sidebar-menu.component';
import { SidebarScheduleComponent } from './layout/sidebar-schedule/sidebar-schedule.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatExpansionModule } from '@angular/material/expansion';
import { HomeOrganizationComponent } from './pages/home/organization/home-organization.component';
import { HomeSecretaryComponent } from './pages/home/secretary/home-secretary.component';
import { HomePractitionerComponent } from './pages/home/practitioner/home-practitioner.component';
import { HomePatientComponent } from './pages/home/patient/home-patient.component';
import { HomeComponent } from './pages/home/home.component';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { PaymentRegistrationComponent } from './pages/payment/registration/payment-registration.component';
import { PaymentComponent } from './pages/payment/payment.component';
import { ScheduleDetailsComponent } from './pages/schedule/status/details/schedule-details.component';
import { PaymentDetailsComponent } from './pages/payment/payment-details/payment-details.component';
import { ScheduleEditStatusComponent } from './pages/schedule/status/edit-status/schedule-edit-status.component';
import { ScheduleSelectComponent } from './pages/schedule/select/schedule-select.component';
import { ScheduleStatusComponent } from './pages/schedule/status/schedule-status.component';
import { CalendarComponent } from './pages/schedule/calendar/calendar.component';
import { ScheduleAppointmentComponent } from './pages/schedule/appointment/schedule-appointment.component';
import { ScheduleProcedureComponent } from './pages/schedule/procedure/schedule-procedure.component';
import { ScheduleComponent } from './pages/schedule/schedule.component';
import { ScheduleRegistrationComponent } from './pages/schedule/registration/schedule-registration.component';
import { NgxEditorModule } from 'ngx-editor';
import { FormDirective } from './core/directives/form-directive';
import { SharedModule } from './modules/shared/shared.module';
import { PractitionerModule } from './modules/practitioner/practitioner.module';
import { OutsideClickDirective } from './core/directives/outside-click.directive';
import { OrganizationModule } from './modules/organization/organization.module';
import { SecretariesModule } from './modules/secretaries/secretaries.module';
import { RegisterComponent } from './pages/registration/register.component';
import { RegisterConfirmationComponent } from './pages/registration/register-confirmation/register-confirmation.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { PatientModule } from './modules/patient/patient.module';
import { GoogleLoginComponent } from './pages/login/google-login/google-login.component';
import { LoadingModalComponent } from './pages/loading-modal/loading-modal.component';
import { NovaSenhaComponent } from './pages/recuperar-senha/nova-senha/nova-senha.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import { CustomSnackBarComponent } from './pages/custom-snackbar/custom-snackbar.component';

registerLocaleData(ptBr);

export function tokenGetter() {
  return localStorage.getItem('token');
}

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    SharedModule,
    PractitionerModule,
    PatientModule,
    OrganizationModule,
    SecretariesModule,
    MatIconModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    MatSidenavModule,
    MatToolbarModule,
    MatMenuModule,
    MatTableModule,
    MatPaginatorModule,
    MatTabsModule,
    MatDialogModule,
    MatDatepickerModule,
    MatInputModule,
    HttpClientModule,
    MatGridListModule,
    MatCardModule,
    MatCheckboxModule,
    MatRadioModule,
    MatSelectModule,
    MatButtonToggleModule,
    MatChipsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSlideToggleModule,
    MatAutocompleteModule,
    MatExpansionModule,
    FormsModule,
    NgxEditorModule,
    MatSnackBarModule,
    MatTooltipModule,
    //GoogleMapsModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    RouterModule.forRoot([{ path: '', component: LoginComponent }]),
    BrowserAnimationsModule,
    NgxMaskModule.forRoot(),
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
      },
    }),
  ],
  declarations: [
    AppComponent,

    NotfoundComponent,
    LoginComponent,
    GoogleLoginComponent,
    RecuperarSenhaComponent,
    NovaSenhaComponent,
    HeaderComponent,
    SidebarMenuComponent,
    SidebarScheduleComponent,
    HomeOrganizationComponent,
    CalendarComponent,
    ScheduleComponent,
    FormDirective,
    OutsideClickDirective,
    HomeComponent,
    HomeSecretaryComponent,
    HomePractitionerComponent,
    HomePatientComponent,
    PaymentRegistrationComponent,
    PaymentComponent,
    PaymentDetailsComponent,
    ScheduleProcedureComponent,
    ScheduleAppointmentComponent,
    ScheduleRegistrationComponent,
    ScheduleStatusComponent,
    ScheduleEditStatusComponent,
    ScheduleSelectComponent,
    ScheduleDetailsComponent,
    RegisterComponent,
    RegisterConfirmationComponent,
    LoadingModalComponent,
    CustomSnackBarComponent,
  ],
  exports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'pt' },
    EncrDecrService,
    MatDatepickerModule,
    MatNativeDateModule,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

/*
Copyright Google LLC. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at https://angular.io/license
*/
